.timeline-container {
    margin: 0 -16px; /* make timeline container full-width */
}
